import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { installChunkLoadRecovery } from './app/core/utils/chunk-load-recovery';

installChunkLoadRecovery();

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.log(err));
